package com.example.mystybag.core.model

import dev.icerock.moko.resources.ImageResource
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.persistentListOf

data class HeaderRowVisualModel(
    val title               : String?                               = null,
    val secondaryTitle      : String?                               = null,
    val buttons             : ImmutableList<ButtonImageVisualModel> = persistentListOf(),
    val profileImage        : ImageDescription?                     = null,
    val trailingImage       : ImageDescription?                     = null,
    val onBackClick         : () -> Unit                            = { },
    val onProfileImageClick : (() -> Unit)?                         = null
)
data class ButtonImageVisualModel(
    val buttonImage         : ImageResource?    = null,
    val buttonText          : String?           = null,
    val isSelected          : Boolean           = false,
    val onButtonClick       : (() -> Unit)?     = null
)